import { useState, useEffect, useRef } from "react";
import domain from "../../../../reusecomponent/domain";
import { useSelector } from "react-redux";
import { getMedia, getMediafixtid, saveMedia } from "../mediaCache";
import { WorningToastContainer } from "../../../function/CustomFunction";

export function VideoPreview({ chat,sending_type }) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const Accesstoken = useSelector((state) => state.Token.value);

  // Function to load the video media
  const loadVideo = async () => {
    setLoading(true);
    setVideoUrl(null); // Reset URL when starting a new load

    try {
      const fileid = chat.file_id;
      if (!fileid) {
          setLoading(false);
          return;
      }

      // 1) Check cached video blob
      const localBlob = await getMedia(chat.body_type,chat.type,fileid);
      if (localBlob.exists) {
        if(localBlob.value ==  null){
          setLoading(false);
          return;
        }
        setVideoUrl(URL.createObjectURL(localBlob.value));
        setLoading(false);
        return;
      }


      // 2) Download from server
      const fileResponse = await fetch(`${domain()}/whatsapp/${sending_type}/video/${fileid}`,
          {method: "GET",
            headers: {
              Authorization: `Bearer ${Accesstoken}`
            }
          }
      );
      if(fileResponse.ok){
        const blob = await fileResponse.blob();
        await saveMedia(chat.body_type, chat.type, fileid, blob);
        setVideoUrl(URL.createObjectURL(blob));
      }else{
        WorningToastContainer("Image not found on server!");
        await saveMedia(chat.body_type, chat.type, fileid, null);
        setLoading(false);
      }

    } catch (e) {
      console.error("Video load failed", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // FIX: Load video whenever chat.file_id changes
    loadVideo();
    
    // Cleanup: Revoke the previous object URL to prevent memory leaks
    return () => {
        if (videoUrl) {
            URL.revokeObjectURL(videoUrl);
        }
    };
    // Re-run whenever the file ID changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat.file_id]); // The essential fix is adding chat.file_id as a dependency


  const playVideo = () => {
    if (videoRef.current) {
      // Check if video is loaded before attempting to play
      if (videoUrl && videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else if (videoUrl && !videoRef.current.paused) {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  return (
    <div
      style={{
        width: "230px",
        height: "380px",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        background: "#eaeaea",
        cursor: "pointer",
      }}
      onClick={playVideo}
    >
      {/* Loader */}
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eaeaea",
          }}
        >
          <div
            style={{
              width: "35px",
              height: "35px",
              border: "4px solid #1ec1f9",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
        </div>
      )}

      {/* Video content */}
      {!loading && videoUrl && (
        <>
          {/* Video element */}
          <video
            ref={videoRef}
            src={videoUrl}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            // Add controls so users can control playback if they want
            controls={false} // Keeping it false for custom overlay, but adding to onClick logic
          />

          {/* Play button (hide if playing) */}
          {!isPlaying && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "60px",
                height: "60px",
                background: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none" // Prevents the button from intercepting the click event
              }}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="#fff"
                style={{ marginLeft: "5px" }}
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          )}

          {/* Duration bottom-left */}
          <div
            style={{
              position: "absolute",
              bottom: "8px",
              left: "8px",
              padding: "3px 6px",
              background: "rgba(0,0,0,0.6)",
              color: "#fff",
              borderRadius: "5px",
              fontSize: "13px",
            }}
          >
            {chat.duration || "0:15"}
          </div>
        </>
      )}
    </div>
  );
}

export function VideoPreviews({ chat }) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const loadVideo = async () => {
    setLoading(true);
    setVideoUrl(null); // Reset URL when starting a new load

    try {
      const fileid = chat.file_id;
      if (!fileid) {
          setLoading(false);
          return;
      }

      // 1) Check cached video blob
      const localBlob = await getMediafixtid(chat.body_type,fileid);
      if (localBlob.exists) {
        if(localBlob.value ==  null){
          setLoading(false);
          return;
        }
        setVideoUrl(URL.createObjectURL(localBlob.value));
        setLoading(false);
        return;
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // FIX: Load video whenever chat.file_id changes
    loadVideo();
    
    // Cleanup: Revoke the previous object URL to prevent memory leaks
    return () => {
        if (videoUrl) {
            URL.revokeObjectURL(videoUrl);
        }
    };
    // Re-run whenever the file ID changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat.file_id]); // The essential fix is adding chat.file_id as a dependency


  const playVideo = () => {
    if (videoRef.current) {
      // Check if video is loaded before attempting to play
      if (videoUrl && videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else if (videoUrl && !videoRef.current.paused) {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  return (
    <div
      style={{
        aspectRatio: "1 / 1",
        width: "100px",
        height: "100px",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        background: "#eaeaea",
        cursor: "pointer",
      }}
      onClick={playVideo}
    >
      {/* Loader */}
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eaeaea",
          }}
        >
          <div
            style={{
              width: "35px",
              height: "35px",
              border: "4px solid #1ec1f9",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
        </div>
      )}

      {/* Video content */}
      {!loading && videoUrl && (
        <>
          {/* Video element */}
          <video
            ref={videoRef}
            src={videoUrl}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            // Add controls so users can control playback if they want
            controls={false} // Keeping it false for custom overlay, but adding to onClick logic
          />

          {/* Play button (hide if playing) */}
          {!isPlaying && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "60px",
                height: "60px",
                background: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none" // Prevents the button from intercepting the click event
              }}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="#fff"
                style={{ marginLeft: "5px" }}
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          )}

          {/* Duration bottom-left */}
          <div
            style={{
              position: "absolute",
              bottom: "8px",
              left: "8px",
              padding: "3px 6px",
              background: "rgba(0,0,0,0.6)",
              color: "#fff",
              borderRadius: "5px",
              fontSize: "13px",
            }}
          >
            {chat.duration || "0:15"}
          </div>
        </>
      )}
    </div>
  );
}